import React from "react";

const inputLabel = ({ label, touched, error, customFeedbackLabel }) => {
  if (touched && error) {
    return <div className="invalid-feedback">{error}</div>;
  }

  if (touched && !error && label) {
    return <div className="valid-feedback">{label} به درستی تکمیل شده است</div>;
  }

  return (
    <div className="feedback">
      {customFeedbackLabel && <>{customFeedbackLabel}</>}
      {/* {!customFeedbackLabel && (
        <>
         <b>{label}</b>
        </>
      )} */}
    </div>
  );
};

const selectLabel = ({ label, touched, error, customFeedbackLabel }) => {
  if (error) {
    // return <div className="invalid-feedback">{error}</div>;
    return <div style={{ color: "red", marginTop: ".5rem" }}>
      {error}
    </div>
  }


  return (
    <div className="feedback">
      {customFeedbackLabel && <>{customFeedbackLabel}</>}
      {/* {!customFeedbackLabel && label && (
        <>
          <b>لطفا یکی از موارد را انتخاب نمایید</b>
        </>
      )} */}
    </div>
  );
};

export function FieldFeedbackLabel({
  label,
  touched,
  error,
  type,
  customFeedbackLabel
}) {
  switch (type) {
    case "text":
      return inputLabel({ label, touched, error, customFeedbackLabel });
    case "email":
      return inputLabel({ label, touched, error, customFeedbackLabel });
    case "password":
      return inputLabel({ label, touched, error, customFeedbackLabel });
    default:
      return selectLabel({ label, touched, error, customFeedbackLabel });
  }
}


// import React from "react";

// const inputLabel = ({ label, touched, error, customFeedbackLabel }) => {
//   if (touched && error) {
//     return <div className="invalid-feedback">{error}</div>;
//   }

//   if (touched && !error && label) {
//     return <div className="valid-feedback">{label} به درستی تکمیل شده است</div>;
//   }

//   return (
//     <div className="feedback">
//       {customFeedbackLabel && <>{customFeedbackLabel}</>}
//       {!customFeedbackLabel && (
//         <>
//           {/* Please enter <b>{label}</b> */}
//         </>
//       )}
//     </div>
//   );
// };

// const selectLabel = ({ label, touched, error, customFeedbackLabel }) => {
//   if (touched && error) {
//     return <div className="invalid-feedback">{error}</div>;
//   }

//   return (
//     <div className="feedback">
//       {customFeedbackLabel && <>{customFeedbackLabel}</>}
//       {!customFeedbackLabel && label && (
//         <>
//           {/* Please select <b>{label}</b> */}
//         </>
//       )}
//     </div>
//   );
// };

// export function FieldFeedbackLabel({
//   label,
//   touched,
//   error,
//   type,
//   customFeedbackLabel
// }) {
//   switch (type) {
//     case "text":
//       return inputLabel({ label, touched, error, customFeedbackLabel });
//     case "email":
//       return inputLabel({ label, touched, error, customFeedbackLabel });
//     case "password":
//       return inputLabel({ label, touched, error, customFeedbackLabel });
//     default:
//       return selectLabel({ label, touched, error, customFeedbackLabel });
//   }
// }
